// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
const _forTrack0 = ($index, $item) => $item.id;
function GuidedWorkflowsStepsComponent_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "li", 3);
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", step_r1.text_content, i0.ɵɵsanitizeHtml);
} }
/**
 *
 * Guided Workflows Steps Component
 * Display the steps of a guided workflow.
 *
 *
 * Input Properties:
 *   steps: list of GuidedWorkflowStep to display.
 *   subcategoryTitle: the title of the subcategory
 *   categoryTitle: the title of the category
 *
 * Output Properties:
 *   stepsChange: EventEmitter to emit the steps.
 *
 */
export class GuidedWorkflowsStepsComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.stepsChange = new EventEmitter();
        this.sanitizedSteps = [];
    }
    ngOnChanges(changes) {
        if (changes.steps) {
            this.sanitizedSteps = this.steps.map((step) => ({
                ...step,
                text_content: this.sanitizer.bypassSecurityTrustHtml(step.text_content),
            }));
        }
    }
    clearSteps() {
        this.stepsChange.emit([]);
    }
}
GuidedWorkflowsStepsComponent.ɵfac = function GuidedWorkflowsStepsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsStepsComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer)); };
GuidedWorkflowsStepsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedWorkflowsStepsComponent, selectors: [["ycn-guided-workflows-steps"]], inputs: { categoryTitle: "categoryTitle", subcategoryTitle: "subcategoryTitle", steps: "steps" }, outputs: { stepsChange: "stepsChange" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 12, vars: 2, consts: [[1, "mb-2", "mt-2", "text-bold", "text-gray-30"], [1, "divider-horizontal", "mt-2", "mb-2"], [1, "pl-2", "mb-row"], [1, "mb-20", 3, "innerHTML"], ["href", "javascript:void(0)", 1, "text-blue", "text-underline-hover", 3, "click"]], template: function GuidedWorkflowsStepsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "hr", 1);
        i0.ɵɵelementStart(3, "ol", 2);
        i0.ɵɵrepeaterCreate(4, GuidedWorkflowsStepsComponent_For_5_Template, 1, 1, "li", 3, _forTrack0);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "hr", 1);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8, "See more ways to ");
        i0.ɵɵelementStart(9, "a", 4);
        i0.ɵɵlistener("click", function GuidedWorkflowsStepsComponent_Template_a_click_9_listener() { return ctx.clearSteps(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(11, ".");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.subcategoryTitle);
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.sanitizedSteps);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.categoryTitle);
    } }, encapsulation: 2 });
